export default __webpack_public_path__ + "static/media/yeild_farm_menu_icon.d83f015e.svg";